module.exports = __webpack_public_path__ + "img/goodcase01.1ff124db.png";